import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';

import {
  HashRouter,
  Routes,
  Route
} from "react-router-dom";

import App from './App';

import Login from './login';

import ProtectedRoute from './components/ProtectedRoute';

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root')
);

root.render(
  <React.StrictMode>

    <HashRouter>

      <Routes>

        {/* 登录页 */}
        <Route
          path="/login"
          element={<Login />}
        />

        {/* 后台系统 */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <App />
            </ProtectedRoute>
          }
        />

      </Routes>

    </HashRouter>

  </React.StrictMode>
);

reportWebVitals();